import PropTypes from 'prop-types';

const TaskDetailController = ({ taskId }) => {
  return <></>;
};
TaskDetailController.propTypes = {
  taskId: PropTypes.number,
};
export default TaskDetailController;
